<template>
  <el-dialog title="退货邀请客户自助下单" :visible.sync="dialogVisible" :before-close="closeDialog" width="750px" :close-on-click-modal="false">
    <div class="bg-tips" style="text-align:left;padding: 0px 0px 10px 0px;">
      <img class="bg-tips-img" src="@/assets/images/returnPickupPrint/bg_Tips.png" alt="" >
      <div class="bg-tips-text1">1、客户扫码下单后，需您确认审核通过才会下单成功，也可设置自动审核；</div>
      <div class="bg-tips-text2">2、修改配置信息后，原二维码与链接将失效，若您需要保留原二维码与链接功能， 请使用新增二维码与链接功能。</div>
    </div>
    <el-form :model="form" label-width="10px" ref="ruleForm" class="y-p-r">
      <div class="big-title y-p-r">
        <span>付款方式</span>
      </div>  
      <el-form-item label="" prop="brokerage">
        <div class="y-mt-15 y-p-r" :class="{'notClickSelf': loadingMaskLayer}">
          <div>
            <el-checkbox v-model="merchanPayFlag" @change="merchanPayFn">商家付运费</el-checkbox>
          </div>
          <div class="y-mt-10">
            <el-checkbox v-model="brokerageFlag" @change="brokerageFn">加价寄件人付费返佣</el-checkbox>
            <span class="y-ml-10" v-if="brokerageFlag&&isAliNameFlag">每单加价</span>
            <el-input-number 
              v-if="brokerageFlag&&isAliNameFlag" 
              class="y-ml-10" 
              v-model="form.brokerage" 
              :precision="1" 
              :step="0.5" 
              :min="0.5" 
              :max="2.0"
             
              size="small"
              :step-strictly="true">
            </el-input-number>   
            元         
            <span class="systemColor y-ml-10 y-c-p" @click="openBrokerageFn('1')">查看详情</span>
          </div>
          <div class="y-mt-10">
            <el-checkbox v-model="buyerPaysShippingFlag" @change="buyerPaysShippingFn">不加价寄件人付运费</el-checkbox>
            <span class="y-ml-10" v-if="buyerPaysShippingFlag">寄件人付</span>
            <el-select class="y-ml-10" v-if="buyerPaysShippingFlag" v-model="buyerPaysShipping" clearable placeholder="请选择">
              <el-option
                v-for="item in addPriceForOrderList"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
            <span class="systemColor y-ml-10 y-c-p" @click="openBrokerageFn('2')">查看详情</span>            
          </div>
          
        </div>
      </el-form-item>               
      <div class="big-title y-p-r">
        <span>自动通过审核</span>
      </div>
      <el-form-item label="" prop="autoAudit">
        <div class="y-f y-f-a y-mt-10">
          <el-switch v-model="form.autoAudit"></el-switch>
          <span class="y-ml-10">开启后，客户扫码下单后，系统自动审核通过并下单成功</span>
        </div>
      </el-form-item>
      <div class="big-title y-p-r">
        <span>退货收件地址</span>
      </div>
      <el-form-item label="" prop="addressId">
        <el-select
          :popper-append-to-body="false"
          popper-class="y-w-600"
          class="y-w-600 y-mt-15"
          v-model="form.addressId"
          filterable
          no-match-text=" "
          placeholder="请选择退货收件地址">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <span @click="showAddReciverInfo = true" class="systemColor y-ml-10 y-c-p">新增地址</span>
      </el-form-item>
      <div class="big-title y-p-r">
        <span>用户下单配置</span>
      </div>
      <el-form-item label="" prop="originalOrder">
        <div class="y-f y-f-a y-c-p y-mt-15">
          <el-checkbox v-model="form.originalOrder">用户下单时需填写原订单号</el-checkbox>
        </div>
      </el-form-item>
      <div class="big-title y-p-r">
        <span>上门取件时间</span>
      </div>
      <el-form-item label="" prop="dayFlag">
        <div class="y-f y-f-a y-c-p y-mt-15 y-fl-20" @click="form.dayFlag='today'">
          <img src="@/assets/images/icon/radio_check_new.png" class="radio-icon" v-if="form.dayFlag=='today'"/>
          <img src="@/assets/images/icon/radio_uncheck.png" class="radio-icon radio-icon-uncheck" v-else/>
          <div class="y-ml-10 y-f-shrink">当日取</div>
          <div class="y-ml-10">消费者下单审核通过后，业务员联系消费者预约取件时间</div>
        </div>
        <div class="y-f y-f-ab y-c-p y-mt-15 y-fl-20" @click="form.dayFlag='nextDay'">
          <div class="y-f y-f-a y-mr-20">
            <img src="@/assets/images/icon/radio_check_new.png" class="radio-icon" v-if="form.dayFlag=='nextDay'"/>
            <img src="@/assets/images/icon/radio_uncheck.png" class="radio-icon radio-icon-uncheck" v-else/>
            <div class="y-ml-10 y-f-shrink">定时取</div>
          </div>
          <div class="align-self">消费者下单审核通过后，为消费者选择的取件时间，若审核时已过预约取件开始时间，将自动调整为审核时间后近2小时</div>
        </div>        
      </el-form-item>
      <div class="big-title y-p-r">
        <span>分享平台</span>
      </div>
      <el-form-item label="" prop="channel">
        <div class="y-f y-f-a y-c-p y-mt-15">
          <el-checkbox-group v-model="channel">
            <el-checkbox label="微信" disabled>微信</el-checkbox>
            <el-checkbox label="淘宝" disabled>淘宝</el-checkbox>
            <el-checkbox label="抖音" disabled>抖音</el-checkbox>
          </el-checkbox-group>          

        </div>
      </el-form-item>             
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="saveSettingInfo">保存</el-button>
    </span>
    <!-- 新增收货地址弹层 -->
    <reciverInfo  :value="showAddReciverInfo" :isNotShowCompany="true" @close="closeReciverDialog"></reciverInfo>
    <!-- 修改订单弹层 -->
    <buyerPaysShippingDialog
      v-if="buyerPaysShippingDialogFlag"
      :isShow="buyerPaysShippingDialogFlag"
      @closeDialog="closeBuyerPaysShipping"
      :alipayName="alipayName"
      :realNameId="realNameId"
      @changeBrokerage="changeBrokerage"
      @openSaveAccount="openSaveAccount"
      ref="buyerPaysShippingDialog"
    ></buyerPaysShippingDialog>    
  </el-dialog>
</template>
<script>
import { getCustomerAddressApi } from '@/api/universal';
import buyerPaysShippingDialog from './buyerPaysShippingDialog.vue';
import reciverInfo from '@/views/baseInfo/printSetting/addressMaintenance/components/ConsigneeInfo.vue';
import { searchAlipayBindApi, saveReturnPlaceOrderConfigApi, resetPlaceOrderQrApi } from '@/api/waybillPrint/returnPickupPrint'
import html2canvas from "html2canvas";
export default {
  name: "record-list",
  components: {
    buyerPaysShippingDialog,
    reciverInfo,
    html2canvas
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      channel: ['微信'],
      realNameId:'',
      buyerPaysShipping:'',
      alipayName:'',
      isAliNameFlag: false,
      buyerPaysShippingDialogFlag: false,
      editRow:null,
      buyerPaysShippingFlag: false,
      brokerageFlag: false,
      addPriceForOrderList:[
        {
          code:'100',
          name:'全额运费',
        }
      ],
      dialogVisible: this.isShow,
      merchanPayFlag: false,
      form: {
        
        buyerPaysShipping:'',
        brokerage:0.5,
        autoAudit: false,
        addressId: '',
        addressInfo: '',
        originalOrder: false,
        dayFlag: 'today',
        qrUrl: '',
      },
      options: [],
      showAddReciverInfo: false,
      isFirst: true,
      logoSrc: '',
      isRefreshQrCode: true,
      loadingDownload: false,
      loadingMaskLayer: false,
    };
  },
  computed: {
    customCondition() { 
      let str = `autoAudit:${this.form.autoAudit ? 1 : 0}|addressId:${this.form.addressId}|originalOrder:${this.form.originalOrder ? 1 : 0}|pickUpDateRule:${this.form.dayFlag == 'today'?0:2}`;
      return str;
    },
    paymentType() {
      return `${this.brokerageFlag ? 1 : 0}|${this.buyerPaysShippingFlag ? 1 : 0}`;
    }
  },
  watch: {
    isShow(val) {
      this.dialogVisible = val;
    },
   'form.brokerage': {
      handler(newVal, oldVal) {
        // 确保值在有效范围内
        if (newVal !== null && newVal !== undefined) {
          let value = parseFloat(newVal);
          if (value < 0.5) {
            this.$nextTick(() => {
              this.$set(this.form, 'brokerage', 0.5);
            });
          } else if (value > 2.0) {
            this.$nextTick(() => {
              this.$set(this.form, 'brokerage', 2.0);
            });
          }
        } else {
          this.$nextTick(() => {
            this.$set(this.form, 'brokerage', 0.5);
          });

        }
      },
      immediate: true
    },    
    customCondition(newVal, oldVal) {
      console.log(`变更了配置 ----${newVal}`)
      let settingInfo = newVal.split('|');
      let addressInfo = settingInfo[1].split(':');
      // 无退货收件地址，不能生成二维码
      if (addressInfo.length < 2 || !addressInfo[1]) {
        return;
      }

      // 获取新地址的具体信息
      let newAddressInfo = '';
      if (isNaN(Number(addressInfo[1]))) {
        newAddressInfo = addressInfo[1];
      } else {
        let list = this.options.filter(t => { return t.value == addressInfo[1]; });
        if (list.length) {
          newAddressInfo = list[0].label;
        }
      }

      // 旧信息， 若是收件地址变更，则要废弃二维码
      let oldSettingInfoArr = oldVal.split('|');
      let oldAddressArr = oldSettingInfoArr.length && oldSettingInfoArr[1].split(':');

      // 获取旧地址的具体信息
      let oldAddressInfo = '';
      if (isNaN(Number(oldAddressArr[1]))) {
        oldAddressInfo = oldAddressArr[1];
      } else {
        let list = this.options.filter(t => { return t.value == oldAddressArr[1]; });
        if (list.length) {
          oldAddressInfo = list[0].label;
        }
      }
      
      let flag = 0; // 0: 不需要刷新， 1: 需要刷新--需要用具体的姓名、电话、手机、省市区、详细地址信息作对比，不一样的才能刷新二维码
      if (oldAddressArr.length && oldAddressInfo != newAddressInfo) {
        flag = 1;
      }

      // 有收件地址信息时，调保存配置接口
      // this.saveSettingInfo(flag);
    },
    brokerageFlag(val) {
      // 确保至少选择一种支付方式
      if(!val && !this.buyerPaysShippingFlag && !this.merchanPayFlag) {
        this.brokerageFlag = true;
        // 优先使用编辑时保存的--这个有多次点击勾选，会多次调用接口， 这个复选框不能去勾选，有多次点击的效果
        let brokerage = this.form.brokerage ? Number(this.form.brokerage) : ((this.editRow && this.editRow.brokerage) || 0.5);
        this.$set(this.form, 'brokerage', brokerage);
      }
    },
    buyerPaysShippingFlag(val) {
      // 确保至少选择一种支付方式
      if(!val && !this.brokerageFlag && !this.merchanPayFlag) {
        this.buyerPaysShippingFlag = true;
        // 优先使用编辑时保存的--这个有多次点击勾选，会多次调用接口， 这个复选框不能去勾选，有多次点击的效果
        this.buyerPaysShipping = this.buyerPaysShipping || ((this.editRow&&this.editRow.buyerPaysShipping==1) ? this.editRow.buyerPaysShipping : '100');
      }
    },
    paymentType(val) {
      let arr = val.split('|') || [];
      if (arr[0] == '1' || arr[1] == '1' ) {
        this.merchanPayFlag = false;
      } else {
        this.merchanPayFlag = true;
      }
    }
  },
  methods: {
    UpDateAlyName(userName){
      this.$refs.buyerPaysShippingDialog.UpDateAlyName(userName);
    },
    openSaveAccount(realNameId){
      this.$emit('openSaveAccount',realNameId);
    },
    searchAlipayBindFn(){
      // 加个遮罩层，以免在请求间隙快速点击取消勾选--需求点自己不能取消勾选
      this.loadingMaskLayer = true;
      searchAlipayBindApi({}).then(res=>{
        this.loadingMaskLayer = false;
        if(res.message=='ok'&&res.data){
          //有支付宝账号说明已经实名
          if(res.data.userName){
            this.buyerPaysShippingFlag = false;
            this.alipayName = res.data.userName;
            this.realNameId = res.data.realNameId;
            this.isAliNameFlag = true;
            if(this.editRow&&this.editRow.brokerage){
              this.form.brokerage = this.form.brokerage ? Number(this.form.brokerage) : this.editRow.brokerage; // 优先使用编辑时保存的--这个有多次点击勾选，会多次调用接口， 这个复选框不能去勾选，有多次点击的效果
            }else{
              this.form.brokerage = this.form.brokerage ? Number(this.form.brokerage) : 0.5;
            }            
          }else{
            // 只要支付宝账号没有绑定，就不能是勾选状态---另外：如一个复选框都没有选中，则选中商家付运费
            this.brokerageFlag = false;
            this.isAliNameFlag = false;
            if (!this.buyerPaysShippingFlag && !this.merchanPayFlag) {
              this.merchanPayFlag = true;
            }
            //没有绑定支付宝  是否实名制 已实名则现实绑定支付弹框 未实名则先实名
            if(res.data.realNameId){
              //未维护支付宝但已经实名 支付宝账号维护 
              this.$emit('openPreAilDialog',this.realNameId)

            }else{
              this.$emit('openPreAilDialog')
            }
          }


        }else{
          console.log("openPreAilDialog");
          this.$emit('openPreAilDialog')
          // this.$emit('openSaveAccount');
          this.brokerageFlag = false;
          this.isAliNameFlag = false;

          if (!this.buyerPaysShippingFlag && !this.merchanPayFlag) {
            this.merchanPayFlag = true;
          }
          //没有绑定支付宝，弹出绑定弹框
        }
      }).catch(err=>{
        this.loadingMaskLayer = false;
        // this.$emit('openSaveAccount');
        this.$emit('openPreAilDialog')
        this.brokerageFlag = false;
        this.isAliNameFlag = false;

        if (!this.buyerPaysShippingFlag && !this.merchanPayFlag) {
          this.merchanPayFlag = true;
        }
        // 没有绑定支付宝，弹出绑定弹框
        // this.$message.error(err.message)
      })
    },
    changeBrokerage(val){
      this.form.brokerage = val;
    },
    closeBuyerPaysShipping(){
      this.buyerPaysShippingDialogFlag = false;
    },
    merchanPayFn() {
      if (this.merchanPayFlag) {
        this.brokerageFlag = false;
        this.buyerPaysShippingFlag = false;
        this.$set(this.form, 'brokerage', (this.editRow&&this.editRow.brokerage) || 0.5);
        this.buyerPaysShipping = '';
      } else if (!this.brokerageFlag && !this.buyerPaysShippingFlag) {
        this.merchanPayFlag = true;
      }
    },
    openBrokerageFn(type){
      // type 1 返佣 2 全额运费      
      this.buyerPaysShippingDialogFlag = true;
      setTimeout(()=>{
        this.$refs.buyerPaysShippingDialog.initData(type,this.form.brokerage)
      },10);
    },
    brokerageFn() {
      //如果brokerageFlag选中则 buyerPaysShippingFlag取消选中并且buyerPaysShipping设置为''
      if(this.brokerageFlag){
        //默认不勾选；勾选后，需校验有无绑定支付宝，若无，则弹出绑定支付宝弹窗
        this.searchAlipayBindFn();
      }
    },
    buyerPaysShippingFn(){
      //如果buyerPaysShippingFlag选中 则brokerageFlag取消选中并且brokerage为0
      if(this.buyerPaysShippingFlag){
        this.brokerageFlag = false;
        this.$set(this.form, 'brokerage', (this.editRow&&this.editRow.brokerage) || 0.5);
        if(this.editRow&&this.editRow.buyerPaysShipping==1){
          this.buyerPaysShipping = this.editRow.buyerPaysShipping
        }else{
          this.buyerPaysShipping = '100';
        }
      }
    },
    initQrCode() {
      if (!this.form.qrUrl) {
        return
      }

      // 二维码刷新
      this.isRefreshQrCode = false;
      this.$nextTick(()=>{
        this.isRefreshQrCode = true;
      })
    },

    // 获取收件人选择下拉列表
    getAddressList(row){
      this.editRow = row;
      let params = {
        isSend: false,
        pageNo: 1,
        limit: 3000,
        name: '',
        telephone: '',
        address: '',
      };
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      getCustomerAddressApi(params).then((res) => {
        if (res.data && res.data.hasOwnProperty('total')) {
          let items = res.data.list || [];
          items.forEach((val) => {
            val.value = val.id
            val.label = `${val.name.trim()} ${val.mobile.trim() ? val.mobile.trim() : val.phone.trim()} ${val.provinceName}${val.cityName}${val.districtName}${val.address.trim()}`
          });
          this.options = items;
        } else {
          this.options = [];
          this.form.addressId = '';
        }
      }).catch(() => {
        this.options = [];
        this.form.addressId = '';
      }).finally(() => {
        // 查询配置信息
        this.getSettingInfo(loadingMask,row);
      });
    },
    closeReciverDialog() {
      this.getAddressList();
      this.showAddReciverInfo = false;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.form = {
        autoAudit: false,
        addressId: '',
        addressInfo: '',
        originalOrder: false,
        dayFlag: 'today',
        qrUrl: '',
      }
      this.$emit("closeDialog");
    },
    // 查询配置信息
    getSettingInfo(loadingMask,row, flag) {
      if(row){
        let data = row;
        this.form.autoAudit = data.autoAudit == 1 ? true : false;
        this.form.addressId = data.addressId ? +data.addressId : '';
        this.form.addressInfo = data.addressInfo || '{}';
        this.form.originalOrder = data.originalOrder == 1 ? true : false;
        this.form.dayFlag = data.pickUpDateRule == 0 ? 'today' : 'nextDay';
        this.form.qrUrl = data.qrUrl;
        let addressInfo = JSON.parse(this.form.addressInfo);
        if (addressInfo.name) {
          let addressInfoLabel = `${addressInfo.name.trim()} ${addressInfo.mobile.trim() ? addressInfo.mobile.trim() : addressInfo.phone.trim()} ${addressInfo.provinceName}${addressInfo.cityName}${addressInfo.districtName}${addressInfo.address.trim()}`;
          let list = this.options.filter(t => { return t.label == addressInfoLabel; });
          // 接口返回的地址信息 在地址列表中不存在时，需将地址信息回显出来
          if (!list.length && addressInfo.name) {
            this.form.addressIdBak = this.form.addressId; // 先把原id备份，保存时要用
            this.form.addressId = addressInfoLabel; // 默认填充值
          }
        }  
        if(data.brokerage){
          this.form.brokerage = data.brokerage;
          this.brokerageFlag = true;
          this.isAliNameFlag = true;
        }
        if(data.buyerPaysShipping==100){
          this.buyerPaysShipping = data.buyerPaysShipping;
          this.buyerPaysShippingFlag = true;
        }

        if (this.brokerageFlag || this.buyerPaysShippingFlag) {
          this.merchanPayFlag = false;
        } else {
          this.merchanPayFlag = true;
        }
      }else{
        this.form = {
          autoAudit: false,
          addressId: '',
          addressInfo: '',
          originalOrder: false,
          dayFlag: 'today',
          qrUrl: '',
        }
        this.merchanPayFlag = true;
      }
      loadingMask.close();
    },
    // 保存配置信息
    saveSettingInfo() {
      // 第一次初始化页面，不需要保存
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });

      
      let params = {
        buyerPaysShipping: '',
        brokerage: 0,
        autoAudit: this.form.autoAudit ? 1 : 0,
        addressId: this.form.addressId,
        originalOrder: this.form.originalOrder ? 1 : 0,
        pickUpDateRule: this.form.dayFlag == 'today' ? 0 : 2,
        qrUrl: '',
      }
      if(this.buyerPaysShippingFlag){
        params.buyerPaysShipping = this.buyerPaysShipping?this.buyerPaysShipping:null;
        params.brokerage = 0;
      }
      if(this.brokerageFlag){
        params.brokerage = Number(this.form.brokerage);
        if(params.brokerage%0.5!=0){
          this.$message.error('佣金必须是0.5的倍数');
          loadingMask.close();
          return;
        }
        params.buyerPaysShipping = null;
      }  
      // 付款方式 两个都没有选中   都是null 有选中全额 100   ，0  选中加价 只传金额
      if(!this.buyerPaysShippingFlag&&!this.brokerageFlag){
        params.buyerPaysShipping = null;
        params.brokerage = null;
      }
      if(this.editRow){
        params.id = this.editRow.id;
      }    
      if (isNaN(Number(this.form.addressId))) {
        // 当前收件地址在 地址薄中已不存在了
        params.addressInfo = this.form.addressInfo;
        params.addressId = this.form.addressIdBak;
      } else {
        let list = this.options.filter(t => { return t.value == this.form.addressId; });
        if (list.length) {
          let obj = {
            name: list[0].name,
            mobile: list[0].mobile,
            phone: list[0].phone,
            provinceName: list[0].provinceName,
            provinceCode: list[0].provinceCode,
            cityName: list[0].cityName,
            cityCode: list[0].cityCode,
            districtName: list[0].districtName,
            districtCode: list[0].districtCode,
            address: list[0].address
          };
          params.addressInfo = JSON.stringify(obj);
        }
      }
      saveReturnPlaceOrderConfigApi(params).then(res => {
        loadingMask.close();
        if (res.status == 200 && res.data) {
          this.$message.success('已重新生成二维码');
          this.dialogVisible = false;
          this.$emit('refreshTable');
        } else {
          this.$message.error(res.error || '保存失败！');
        }
      }).catch(()=>{
        loadingMask.close();
      })
    }
  },
  mounted() {
    this.logoSrc = require('@/assets/images/icon/Logo_YTO@2x.png');
    if (this.isEdit && this.rowInfo && this.rowInfo.id) {
      this.getAddressList(this.rowInfo);
    } else {
      this.getAddressList();
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 10px 32px;
}
/deep/ .el-dialog__footer {
  text-align: right;
  border-top: 1px solid #EDEDED;
}
/deep/ .el-alert--warning.is-light {
  background: rgba(239,176,65,0.12);
  border-radius: 8px;
  border: 0;
  .el-alert__icon.el-icon-warning {
    align-self: baseline;
    margin-top: 5px;
    width: 24px;
    font-size: 24px;
  }
  .el-alert__description {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }
}
.bg-tips{
  position: relative;
  font-size: 14px;
  color: #732C4A;  
}
.bg-tips-img{
  width: 100%;
}
.bg-tips-text1{
  width: 72%;
  position: absolute;
  top:38px;
  left: 28px;
}
.bg-tips-text2{
  width: 72%;
  position: absolute;
  top:60px;
  left: 28px;  
  line-height: 16px;
}
.collapseBtn {
  width: 53px;
  height: 32px;
  cursor: pointer;
}
.collapseBtn.off{
  color: #EEEEEE;
}
.radio-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.big-title {
  padding-left: 10px;
  letter-spacing: 1px;
  padding-left: 10px;
  font-weight: 800;
  font-size: 14px;  
}
.big-title::before {
  content: " ";
  position: absolute;
  left: 0px;
  top: 2px;
  width: 2px;
  height: 12px;
  background: #653EB3;
}
.y-ml-190 {
  margin-left: 200px;
}
.align-self {
  align-self: flex-start;
}
.logo-overlay {
  width: 50px;
  height: 50px;
}
.qr-container {
  width: 132px;
  height: 132px;
  background: #fff;
  .qrbg {
    position: absolute;
    top: 0;
    left: 0;
    width: 132px;
    height: 132px;
    z-index: 1;
  }
  .custom-qr {
    position: absolute;
    top: 6px;
    left: 6px;
    z-index: 1;
  }
}
.download-box {
  position: absolute;
  left: -50000px;
}
.qr-container-saveImg {
  width: 252px;
  height: 252px;
  background: #fff;
  .qrbg {
    position: absolute;
    top: 0;
    left: 0;
    width: 252px;
    height: 252px;
    z-index: 1;
  }
  .custom-qr {
    position: absolute;
    top: 6px;
    left: 6px;
    z-index: 1;
  }
}
.notClickSelf {
  pointer-events: none;
  cursor: not-allowed;
}
</style>